import * as htmlToImage from 'html-to-image';
import { AdminDashboards } from '../../../variables/constant';
import { PdfProps, adjustWidgetElementHeightWidth, pdfNewPage } from '../../../utils/pdf';

export const PerformancePdf = async ({
  pdfDoc,
  pageWidth,
  pageHeight,
  pdfMargin,
  pdfPadding,
  posX,
  posY,
}: PdfProps) => {
  // Export Widgets one by one
  for (const widget of Object.values(AdminDashboards.performance)) {
    const widgetElement = document.getElementById(widget.name) as HTMLElement;
    const png = await htmlToImage.toPng(widgetElement);

    let elHeight = widgetElement.offsetHeight;
    let elWidth = widgetElement.offsetWidth;

    if ([
      AdminDashboards.performance.TasksAssignedNCompletedWidget.name,
      AdminDashboards.performance.PerformanceSliderWidget.name,
    ].includes(widget.name)) {
      [elHeight, elWidth] = adjustWidgetElementHeightWidth(widgetElement, pageWidth / 2, 10);
      [posX, posY] = pdfNewPage(pdfDoc, pageHeight, pdfMargin, pdfPadding, posX, posY, elHeight);
      if (widget.name === AdminDashboards.performance.TasksAssignedNCompletedWidget.name) {
        posX = pdfDoc.internal.pageSize.width - pdfMargin - elWidth + 5;
        posY -= 5;
      }
    } else {
      [elHeight, elWidth] = adjustWidgetElementHeightWidth(widgetElement, pageWidth, pdfMargin);
      [posX, posY] = pdfNewPage(pdfDoc, pageHeight, pdfMargin, pdfPadding, posX, posY, elHeight);
    }
    pdfDoc.addImage(png, 'PNG', posX, posY, elWidth, elHeight, widget.name, 'NONE');
    if (widget.name !== AdminDashboards.performance.PerformanceSliderWidget.name) {
      posY += elHeight + pdfPadding;
    }
  }
};